import { Dispatch, SetStateAction } from 'react';
import { useMutation, useQueryClient } from 'react-query';

import { errorMessage } from '@features/applications';
import axiosInstance from '@server/axiosInstance';
import { adminsUserDeleteRoute } from '../api/constant';
import { adminsList } from '../constants';
import { AxiosError } from 'axios';

type useDeleteAdminUserProps = {
    setAlertText?: Dispatch<SetStateAction<string>>;
};

export const useDeleteAdminUser = ({
    setAlertText = () => { },
}: useDeleteAdminUserProps) => {
    const client = useQueryClient();

    const { mutate: deleteAdminUser, isLoading: isdeleteingAdminUserLoading } =
        useMutation({
            mutationFn: (variables: {
                admin_id: number | string;
            }) =>
                axiosInstance
                    .post(adminsUserDeleteRoute, variables, {
                        headers: {
                            'Content-Type': 'multipart/form-data',
                        },
                    })
                    .then((res) => res.data),
            onSuccess: (data) => {
                client.invalidateQueries([adminsList]);
                setAlertText('');
            },
            onError: (data: any) => {
                setAlertText(data?.response?.data?.message || errorMessage);
            },
        });
    return {
        deleteAdminUser,
        isdeleteingAdminUserLoading,
    };
};
